export default {
	/**
	 * 权限应用方案.
	 * type:
	 * 1 - 通过全局变量
	 * 2 - 通过 ajax
	 */
	permScheme: {
		type: 1,
		getCodes(){
			// 返回权限码列表。一般由服务器直接打印到页面中。
			// 如: ['/perm/code/1', '/perm/code/2']
			window.serverPerms = ['/perm/code/1', '/perm/code/2']
			return window.serverPerms
		}
		// ,
		// type: 2,
		// getCodes(){
		// 	// return a Promise
		// 	return _api.site.getUserPerm()
		// }
	}
}
